<div>
    <a class="ace-btn btn-link pointer" (click)="showTaxingDistricts()">
        Taxing Districts <span>({{ assessor?.taxingDistrictModels?.length | number:'1.0-0' }})</span>
    </a>
</div>
